import { render } from "./AddSupportCoursPage.vue?vue&type=template&id=b95ec6be&ts=true"
import script from "./AddSupportCoursPage.vue?vue&type=script&lang=ts"
export * from "./AddSupportCoursPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__